module.exports = __webpack_public_path__ + "img/clase2.1b10e730.svg";